import { parseErrors, Toast } from 'helpers';
import { getUser } from 'queries';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { RootStore } from 'store';
import type { JsonDataItem, User, UserResponse } from 'types';

const useUserInfo: () => [User | undefined, boolean] = () => {
  const { data, error, isInitialLoading: isLoading } = useQuery<UserResponse, JsonDataItem>(['get-user'], getUser);
  const { setUser } = RootStore;

  useEffect(() => {
    if (error) Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
  }, [error]);

  const skillsets =
    data?.skillsets?.map(({ name, icon, class: className, intraining }) => ({
      name,
      icon,
      type: className.replace('userskill-', ''),
      inTraining: !!intraining,
    })) ?? [];

  useEffect(() => {
    if (data) setUser({ ...data, skillsets });
  }, [data]);

  return [data && { ...data, skillsets }, isLoading];
};

export default useUserInfo;
